import {DetailsPageAppProps} from '../../../../app/interfaces'
import {connect} from '../../../../runtime-context/context'
import {getBestPurchasedPlan, getSelectedPaidPlan} from '../../../../../selectors/paid-plans'
import {FooterRuntimeProps, FooterOwnProps} from './interfaces'
import {Footer as Presentation} from './footer'

const mapRuntime = ({state, actions: {setShowAccessibilityMode}}: DetailsPageAppProps): FooterRuntimeProps => ({
  event: state.event,
  tickets: state.tickets,
  paidPlan: getSelectedPaidPlan(state) || getBestPurchasedPlan(state),
  selectedPlaces: state.seating.selectedPlaces,
  selectedTickets: state.selectedTickets,
  showAccessibilityMode: state.seating.showAccessibilityMode,
  setShowAccessibilityMode,
})

export const Footer = connect<FooterOwnProps, FooterRuntimeProps>(mapRuntime)(Presentation)
export * from './interfaces'
